"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.App = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _shuffle = _interopRequireDefault(require("shufflejs/dist/shuffle.min"));
var _customers = require("./customers");
var _imagesloaded = _interopRequireDefault(require("imagesloaded"));
var _jqueryFancybox = _interopRequireDefault(require("@fancyapps/fancybox/dist/jquery.fancybox.min"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var App = /*#__PURE__*/function (_React$Component) {
  _inherits(App, _React$Component);
  var _super = _createSuper(App);
  function App(props) {
    var _this;
    _classCallCheck(this, App);
    _this = _super.call(this, props);
    _this.state = {
      projectsContainer: /*#__PURE__*/_react["default"].createElement("div", null, "Aucun projet pr\xE9sent."),
      customersList: null
    };
    _this.projectsRouteHandler = _this.projectsRouteHandler.bind(_assertThisInitialized(_this));
    _this.clearFocus = _this.clearFocus.bind(_assertThisInitialized(_this));
    _this.setFocus = _this.setFocus.bind(_assertThisInitialized(_this));
    _this.setFilterFocus = _this.setFilterFocus.bind(_assertThisInitialized(_this));
    _this.clearFilterFocus = _this.clearFilterFocus.bind(_assertThisInitialized(_this));
    _this.setFilterParam = _this.setFilterParam.bind(_assertThisInitialized(_this));
    _this.openFancyBox = _this.openFancyBox.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(App, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      localStorage.setItem('arche-site-realisations-filter-param', 'all');
      this.setState({
        customersList: _customers.customers.map(function (customerItem) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: 'customer-' + customerItem.id,
            onClick: function onClick(e) {
              return _this2.projectsRouteHandler(e, customerItem.id, customerItem.name, customerItem.projects, customerItem.logo);
            },
            className: "project-item-name my-1 center-align"
          }, customerItem.name);
        })
      });

      // We show all projects
      document.querySelector("#show-all-projects-button").click();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // Initialize Shuffle.js
      var that = this;

      // On utilise la librairie imagesloaded pour régler le bug avec shuffle js qui faisait que les images ne s'affichaient
      // pas en totalité suite à un calcul de la hauteur des images au moment où celles-ci n'ont pas encore été totalement chargées
      (0, _imagesloaded["default"])(document.querySelector('#realisations-container'), function () {
        var filterParam = localStorage.getItem('arche-site-realisations-filter-param');
        if (filterParam && filterParam != null && filterParam != undefined && filterParam != 'undefined') {
          that.initShuffleJS(filterParam);
          var element = document.querySelector(".sort-btn-container button[data-filter-param=\"".concat(filterParam, "\"]"));
          that.setFilterFocus(element, filterParam);
        } else {
          that.initShuffleJS();
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.shuffleInstance = null;
    }
  }, {
    key: "projectsRouteHandler",
    value: function projectsRouteHandler(event, customerId, customerName, projects, customerLogo) {
      var _this3 = this;
      event.preventDefault();
      this.clearFocus();
      this.setFocus(event);
      var dropdownBtn = document.getElementById('dropdownProjectsOwners');
      if (customerName === 'all') {
        dropdownBtn.textContent = 'Tous les clients';
      } else {
        dropdownBtn.textContent = customerName;
      }
      if (customerId === 0) {
        // On affiche tous les projets si customerId est égal à 0
        this.setState({
          projectsContainer: _customers.customers.map(function (customerItem) {
            return customerItem.projects.map(function (projectItem) {
              return /*#__PURE__*/_react["default"].createElement("div", {
                key: 'customer-' + customerId + '-project-' + projectItem.id,
                className: "col-md-3 px-2 pb-3 realisations-img-container scale-anim",
                "data-groups": JSON.stringify(projectItem.project_categories),
                onClick: function onClick(e) {
                  return _this3.openFancyBox(projectItem, e);
                }
              }, /*#__PURE__*/_react["default"].createElement("div", {
                className: "card shadow"
              }, /*#__PURE__*/_react["default"].createElement("img", {
                className: "card-img-top",
                src: projectItem.files[0].thumbnail.url,
                alt: projectItem.name,
                style: {
                  width: 100 + '%'
                }
              }), /*#__PURE__*/_react["default"].createElement("div", {
                className: "card-text p-2 project-images-count-container"
              }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
                className: "see-picture p-1"
              }, /*#__PURE__*/_react["default"].createElement("svg", {
                enableBackground: "new 0 0 512 512",
                height: "20px",
                id: "Layer_1",
                version: "1.1",
                viewBox: "0 0 512 512",
                width: "512px",
                xmlSpace: "preserve",
                xmlns: "http://www.w3.org/2000/svg",
                xmlnsXlink: "http://www.w3.org/1999/xlink"
              }, /*#__PURE__*/_react["default"].createElement("path", {
                d: "M497.913,497.913c-18.782,18.782-49.225,18.782-68.008,0l-84.862-84.863c-34.889,22.382-76.13,35.717-120.659,35.717  C100.469,448.767,0,348.312,0,224.383S100.469,0,224.384,0c123.931,0,224.384,100.452,224.384,224.383  c0,44.514-13.352,85.771-35.718,120.676l84.863,84.863C516.695,448.704,516.695,479.131,497.913,497.913z M224.384,64.109  c-88.511,0-160.274,71.747-160.274,160.273c0,88.526,71.764,160.274,160.274,160.274c88.525,0,160.273-71.748,160.273-160.274  C384.657,135.856,312.909,64.109,224.384,64.109z",
                fill: "white"
              })))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
                className: "project-images-count p-1"
              }, projectItem.files.length + " ", /*#__PURE__*/_react["default"].createElement("img", {
                src: "assets/images/photos_logo.svg",
                alt: "Dessin d'une carte photo"
              })))), /*#__PURE__*/_react["default"].createElement("div", {
                className: "card-body p-1"
              }, /*#__PURE__*/_react["default"].createElement("div", {
                className: "row m-0"
              }, /*#__PURE__*/_react["default"].createElement("div", {
                className: "col-2 col-md-3 p-1"
              }, /*#__PURE__*/_react["default"].createElement("img", {
                className: "customer-logo-for-project px-1 pt-1",
                src: customerItem.logo,
                title: customerItem.name,
                alt: customerItem.name
              })), /*#__PURE__*/_react["default"].createElement("div", {
                className: "col-10 col-md-9 project-name-container"
              }, /*#__PURE__*/_react["default"].createElement("div", {
                className: "card-title project-name m-0"
              }, projectItem.name))))));
            });
          })
        });
      } else {
        this.setState({
          projectsContainer: projects.map(function (projectItem) {
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: 'customer-' + customerId + '-project-' + projectItem.id,
              className: "col-md-3 px-2 pb-3 realisations-img-container scale-anim",
              "data-groups": JSON.stringify(projectItem.project_categories),
              onClick: function onClick(e) {
                return _this3.openFancyBox(projectItem, e);
              }
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: "card shadow"
            }, /*#__PURE__*/_react["default"].createElement("img", {
              className: "card-img-top",
              src: projectItem.files[0].thumbnail.url,
              alt: projectItem.name,
              style: {
                width: 100 + '%'
              }
            }), /*#__PURE__*/_react["default"].createElement("div", {
              className: "card-text p-2 project-images-count-container"
            }, /*#__PURE__*/_react["default"].createElement("span", {
              className: "project-images-count p-1"
            }, projectItem.files.length, " ", /*#__PURE__*/_react["default"].createElement("i", {
              className: "far fa-images"
            }))), /*#__PURE__*/_react["default"].createElement("div", {
              className: "card-body p-1"
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: "row m-0"
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: "col-2 col-md-3 p-1"
            }, /*#__PURE__*/_react["default"].createElement("img", {
              className: "customer-logo-for-project px-1 pt-1",
              src: customerLogo,
              title: customerName,
              alt: customerName
            })), /*#__PURE__*/_react["default"].createElement("div", {
              className: "col-10 col-md-9 project-name-container"
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: "card-title project-name m-0"
            }, projectItem.name))))));
          })
        });
      }
    }

    /**
     * Remove the focus from all projects names
     */
  }, {
    key: "clearFocus",
    value: function clearFocus() {
      var buttons = document.querySelectorAll('.project-item-name');
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].classList.remove('active');
      }
    }
  }, {
    key: "setFocus",
    value: function setFocus(event) {
      event.target.classList.add('active');
    }
  }, {
    key: "initShuffleJS",
    value: function initShuffleJS() {
      var group = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _shuffle["default"].ALL_ITEMS;
      var container = document.querySelector('#realisations-container');
      var sizer = document.querySelector('.realisations-column-sizer');
      this.shuffleInstance = new _shuffle["default"](container, {
        itemSelector: '.realisations-img-container',
        sizer: sizer,
        group: group
      });
    }

    /**
     * Set the focus to the selected filter parameter
     *
     * @param {*} event
     * @param {*} filterParam
     * @memberof App
     */
  }, {
    key: "setFilterFocus",
    value: function setFilterFocus(event, filterParam) {
      localStorage.setItem('arche-site-realisations-filter-param', filterParam);
      this.clearFilterFocus();
      var dropdownBtn = document.getElementById('dropdownProjectsCategories');
      switch (filterParam) {
        case 'all':
          dropdownBtn.textContent = 'Toutes les catégories';
          break;
        case 'creations':
          dropdownBtn.textContent = 'Créations';
          break;
        case 'marketing':
          dropdownBtn.textContent = 'Marketing';
          break;
        case 'applications':
          dropdownBtn.textContent = 'Applications';
          break;
        case 'events':
          dropdownBtn.textContent = 'Evénementiel';
          break;
        case 'com-supports':
          dropdownBtn.textContent = 'Supports de communication';
          break;
        case 'surveys':
          dropdownBtn.textContent = 'Enquêtes';
          break;
        default:
          break;
      }
      if (filterParam === 'all') {
        this.setFilterParam(['creations', 'marketing', 'applications', 'events', 'com-supports', 'surveys']);
      } else {
        this.setFilterParam(filterParam);
      }
      if (event.target) {
        event.target.classList.add('active');
      } else {
        event.classList.add('active');
      }
    }

    /**
     * Set filter parameter
     *
     * @param {*} filterParam
     * @memberof App
     */
  }, {
    key: "setFilterParam",
    value: function setFilterParam(filterParam) {
      this.shuffleInstance.filter(filterParam);
    }

    /**
     * Removes focus from all filter buttons
     *
     * @memberof App
     */
  }, {
    key: "clearFilterFocus",
    value: function clearFilterFocus() {
      var buttons = document.querySelectorAll('.sort-btn-container button');
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].classList.remove('active');
      }
    }
  }, {
    key: "openFancyBox",
    value: function openFancyBox(project, event) {
      event.preventDefault();
      var files = project.files.map(function (fileItem) {
        return {
          src: fileItem.url,
          opts: {
            caption: fileItem.description,
            thumb: fileItem.thumbnail.url
          }
        };
      });
      $.fancybox.open(files, {
        loop: false,
        image: {
          // Wait for images to load before displaying
          //   true  - wait for image to load and then display;
          //   false - display thumbnail and load the full-sized image over top,
          //           requires predefined image dimensions (`data-width` and `data-height` attributes)
          preload: false
        },
        thumbs: {
          autoStart: true
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "customer-project-component"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "row py-5"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col center-align"
      }, /*#__PURE__*/_react["default"].createElement("h2", null, "Nos r\xE9alisations"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "dropdown d-inline-block m-1"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-primary dropdown-toggle",
        type: "button",
        id: "dropdownProjectsCategories",
        "data-toggle": "dropdown",
        "aria-haspopup": "true",
        "aria-expanded": "false"
      }, "Cat\xE9gories de projets"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "dropdown-menu sort-btn-container p-1",
        "aria-labelledby": "dropdownProjectsCategories"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        "data-filter-param": "creations",
        onClick: function onClick(e) {
          return _this4.setFilterFocus(e, 'creations');
        },
        className: "dropdown-item btn my-1"
      }, "Cr\xE9ations"), /*#__PURE__*/_react["default"].createElement("button", {
        "data-filter-param": "com-supports",
        onClick: function onClick(e) {
          return _this4.setFilterFocus(e, 'com-supports');
        },
        className: "dropdown-item btn my-1"
      }, "Supports de communication"), /*#__PURE__*/_react["default"].createElement("button", {
        "data-filter-param": "marketing",
        onClick: function onClick(e) {
          return _this4.setFilterFocus(e, 'marketing');
        },
        className: "dropdown-item btn my-1"
      }, "Marketing"), /*#__PURE__*/_react["default"].createElement("button", {
        "data-filter-param": "applications",
        onClick: function onClick(e) {
          return _this4.setFilterFocus(e, 'applications');
        },
        className: "dropdown-item btn my-1"
      }, "Applications"), /*#__PURE__*/_react["default"].createElement("button", {
        "data-filter-param": "events",
        onClick: function onClick(e) {
          return _this4.setFilterFocus(e, 'events');
        },
        className: "dropdown-item btn my-1"
      }, "\xC9v\xE9nementiel"), /*#__PURE__*/_react["default"].createElement("button", {
        "data-filter-param": "surveys",
        onClick: function onClick(e) {
          return _this4.setFilterFocus(e, 'surveys');
        },
        className: "dropdown-item btn my-1"
      }, "Enqu\xEAtes"), /*#__PURE__*/_react["default"].createElement("button", {
        "data-filter-param": "all",
        onClick: function onClick(e) {
          return _this4.setFilterFocus(e, 'all');
        },
        className: "dropdown-item btn my-1"
      }, "Toutes les cat\xE9gories"))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "dropdown d-inline-block m-1"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-primary dropdown-toggle",
        type: "button",
        id: "dropdownProjectsOwners",
        "data-toggle": "dropdown",
        "aria-haspopup": "true",
        "aria-expanded": "false"
      }, "Clients"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "dropdown-menu sort-btn-container p-1",
        "aria-labelledby": "dropdownProjectsOwners"
      }, this.state.customersList, /*#__PURE__*/_react["default"].createElement("div", {
        onClick: function onClick(e) {
          return _this4.projectsRouteHandler(e, 0, 'all', [], null);
        },
        className: "project-item-name center-align",
        id: "show-all-projects-button"
      }, "Tous les clients"))))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-md-12"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: "realisations-container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "card col-md-3 realisations-column-sizer"
      }), this.state.projectsContainer))))))));
    }
  }]);
  return App;
}(_react["default"].Component);
exports.App = App;
_reactDom["default"].render( /*#__PURE__*/_react["default"].createElement(App, null), document.querySelector('#realisations'));